import { useState } from "react";
import { Input } from "./ui/Input";
import { Select } from "./ui/Select";
import { Textarea } from "./ui/Textarea";
import { SelectCountry } from "./selectors/country/selectCountry";
import { SelectCompanyType } from "./selectors/companyType/selectCompanyType";
import { userSession } from "../observers/userObserver";
import config from "./config";
import ConfirmationModal from "./ui/ConfirmationModal";
export default function AdverseMediaSearch() {
  const [SearchentityType, setSearchentityType] = useState("Individual");
  const [formData, setFormData] = useState({
    entityCountry: "",
    name: "",
    entityCompanyType: "",
    depthOfSearch: 7,
    additionalInfo: "",
  });
  const [loading, setLoading] = useState(false);
 const userEmail = userSession.getUserEmail();
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState("");
  // generic input change (for Input fields)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ FIX: works whether SelectCountry passes event or direct value
  const handleCountryChange = (arg) => {
    const value =
      typeof arg === "string" ? arg : arg?.target?.value ?? "";
    setFormData((prev) => ({ ...prev, entityCountry: value }));
  };

  // ✅ FIX: works whether Select passes event or direct value
  const handleEntityChange = (arg) => {
    const value =
      typeof arg === "string" ? arg : arg?.target?.value ?? "";
    setSearchentityType(value);
    if (value !== "Company") {
      setFormData((prev) => ({ ...prev, entityCompanyType: "" }));
    }
  };

  const handleCompanyTypeChange = (arg) => {
    const value =
      typeof arg === "string" ? arg : arg?.target?.value ?? "";
    setFormData((prev) => ({ ...prev, entityCompanyType: value }));
  };

  const makeMediaSearch = async (payload) => {
    try {
      const token = userSession.getToken();
      const response = await fetch(`${config["backend-url"]}/ubo_adverseMedia`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        return data;
      } else {
        console.error("Failed to make media search", data);
        throw new Error(data.error || "Failed to make media search");
      }
    } catch (error) {
      console.error("Error during API call:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        entityName: formData.name,
        name: formData.name,
        country: formData.entityCountry,
        entityType: SearchentityType.toLowerCase(),
        dateRange: formData.depthOfSearch,
        additionalInfo: formData.additionalInfo,
        ubos: [],
        managers: []
      };

      console.log("Submitting payload:", payload);
      const result = await makeMediaSearch(payload);
      console.log("Media search initiated:", result);
       setConfirmationMessage(
      `Adverse Media Search has been successfully processed. The report will be emailed to ${userEmail} in 30 minutes.`
    );


    } catch (error) {
      console.error("Error submitting form:", error);
      // alert(`Error: ${error.message}`);
      setConfirmationMessage(
      `Something went wrong while processing the search: ${error.message}`
    );
    } finally {
      setLoading(false);
      setConfirmationModal(true);
    }
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1 className="welcomeText">COnD Adverse Media Search</h1>
      </div>

      <div className="transaction-form form_information">
        <form onSubmit={handleSubmit} className="search-form">
          <SelectCountry
            label="Country of residence/incorporation"
            name="entityCountry"
            value={formData.entityCountry}
            onChange={handleCountryChange}
          />

          <Input
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter name"
            required
          />

          <Select
            label="Individual or Company"
            name="SearchentityType"
            value={SearchentityType}
            onChange={handleEntityChange}
            required
            options={[
              { value: "Individual", display_value: "Individual" },
              { value: "Company", display_value: "Company" },
            ]}
          />

          {SearchentityType === "Company" && (
            <SelectCompanyType
              label="Company Type"
              name="entityCompanyType"
              value={formData.entityCompanyType}
              onChange={handleCompanyTypeChange}
              country={formData.entityCountry}
            />
          )}

          <Input
            label="Depth of Search (Years)"
            type="number"
            name="depthOfSearch"
            value={formData.depthOfSearch}
            onChange={handleChange}
            min="1"
          />

          <Textarea
            label="Additional Identifying Information"
            name="additionalInfo"
            value={formData.additionalInfo}
            onChange={handleChange}
            placeholder="e.g. date of birth, nationality, registration number, known aliases, parent company, or any other details that help narrow the search"
          />

          <button
  type="submit"
  className="add-request"
  disabled={loading}
  
>
  {loading ? "Searching..." : "Search"}
</button>
         <ConfirmationModal
  isOpen={confirmationModal}
  onClose={() => setConfirmationModal(false)}
  message={confirmationMessage}
/>
        </form>
      </div>
    </div>
  );
}
